import styled from 'styled-components';
import { atomicBlockContainerWidth, borderRadius, colorUsage, fontSize, getSpacing, typography } from 'stylesheet';
import { Recipe as RecipeIconSvg } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "RecipeBlockstyle__Container",
  componentId: "sc-1si4zj1-0"
})(["width:", ";margin:auto;padding:", " ", " ", " ", ";overflow-wrap:anywhere;background-color:", ";border:1px solid ", ";border-radius:", ";"], atomicBlockContainerWidth, getSpacing(1), getSpacing(2), getSpacing(2), getSpacing(2), colorUsage.embedBlockBackground, colorUsage.embedBorder, borderRadius.medium);
var Header = styled.div.withConfig({
  displayName: "RecipeBlockstyle__Header",
  componentId: "sc-1si4zj1-1"
})(["display:flex;align-items:center;margin-bottom:", ";cursor:default;user-select:none;"], getSpacing(0.5));
var RecipeIcon = styled(RecipeIconSvg).withConfig({
  displayName: "RecipeBlockstyle__RecipeIcon",
  componentId: "sc-1si4zj1-2"
})(["flex:0 0 14px;margin-right:", ";vertical-align:middle;path{fill:", ";}"], getSpacing(0.4), colorUsage.embedBlockForeground);
var RecipeTitle = styled.span.withConfig({
  displayName: "RecipeBlockstyle__RecipeTitle",
  componentId: "sc-1si4zj1-3"
})(["color:", ";font-size:", ";"], colorUsage.embedBlockForeground, fontSize.smaller);
var Recipe = styled.div.withConfig({
  displayName: "RecipeBlockstyle__Recipe",
  componentId: "sc-1si4zj1-4"
})(["", ";padding:", ";background-color:", ";border-radius:", ";"], typography.code, getSpacing(1), colorUsage.embedBlockForeground, borderRadius.medium);
export { Container, Recipe, RecipeIcon, RecipeTitle, Header };